import { IAdFoxBannerContext } from '@cian/adfox';
import * as React from 'react';

import { Container } from '../../../components/Container';
import {
  SIZE_100,
  SIZE_WIDE,
} from '../../../constants/sizes';
import { Link } from '../../../components/Link';
import { Image } from '../../../components/Image';

export type TParallaxBannerProps = {
  context: IAdFoxBannerContext,
  onMount?(): void;
};

export class ParallaxBanner extends React.Component<TParallaxBannerProps, {}> {
  public componentDidMount() {
    if (this.props.onMount) {
      this.props.onMount();
    }
  }

  public render() {
    const {
      imageURL,
      trackingUrl,
      alt,
      reference,
    } = this.props.context;

    return (
      <Container
        width={SIZE_WIDE}
        maxWidth={SIZE_WIDE}
        height={SIZE_100}
      >
        <Link
          url={reference}
          target="blank"
          alt={alt}
        >
          <Container>
            <Container
            >
              <Image src={imageURL} />
            </Container>
            <Container>
              <Image src={trackingUrl} />
            </Container>
          </Container>
        </Link>
      </Container>
    );
  }
}
